import Input from '@/common/components/base/input/base/Input.tsx';
import formResetAttachment from '@/common/components/base/input/base/attachments/FormResetAttachment.tsx';
import { convertToEnglishDigits } from '@/common/components/base/input/base/changeHandlers/convertToEnglishDigits';
import { TNumberInputWithWords } from '@/common/components/base/numberInputWithWords/numberInputWithWords.type';
import Typography from '@/common/components/base/typography/Typography';
import num2persian from 'num2persian';
import { ChangeEventHandler } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Box } from 'styled-system/jsx';

function formatNumberWithCommas(value: string) {
  const number = value.replace(/\D/g, '');
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function formatNumberWithOutCommas(value: string) {
  const number = value.replace(/\D/g, '');
  return number;
}

const NumberInputWithWords = ({
  name,
  rules,
  label,
  placeholder,
  onChange,
  disabled,
  defaultValue = '',
  direction,
  placeholderAlign,
  optionalLabel,
  max,
  showPriceToWords = true,
  hasSeparator = true,
  hasZeroAsDefault = true,
}: TNumberInputWithWords) => {
  const { control, trigger } = useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });
  const { field, fieldState } = controller;
  const errorMessage = fieldState.error?.message;

  const inputOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = convertToEnglishDigits(e.target.value);
    if (hasSeparator) {
      const formatted = formatNumberWithCommas(value);
      field.onChange(formatted);
      onChange?.(formatted);
    } else {
      const formatted = formatNumberWithOutCommas(value);
      field.onChange(formatted);
      onChange?.(formatted);
    }
  };

  const onReset = () => {
    field.onChange('');
    onChange?.('');
  };

  const numberInWords =
    field.value && String(field.value).replace(/,/g, '') !== '0'
      ? num2persian(Math.floor(+String(field.value).replace(/,/g, '') / 10)) +
        ' تومان'
      : '';
  return (
    <div>
      <Input
        inputProps={{
          value: field.value,
          onChange: inputOnChange,
          placeholder,
          disabled,
          maxLength: max,
          inputMode: 'numeric',
          pattern: '[0-9,]*',
          onFocus: (e) => {
            if (e.target.value === '0') e.target.value = '';
          },
          onBlur: (e) => {
            if (e.target.value === '' && hasZeroAsDefault) {
              ((e.target.value = '0'), field.onChange('0'));
              onChange?.('0');
              trigger(name);
            }
          },
        }}
        optionalLabel={optionalLabel}
        inputRef={field.ref}
        errorMessage={errorMessage}
        label={label}
        direction={direction}
        placeholderAlign={placeholderAlign}
        endAttachments={[
          formResetAttachment({
            onReset,
            renderCondition: !!field.value && !disabled,
          }),
        ]}
      />
      {showPriceToWords && !errorMessage && (
        <Box position="relative" bottom="15px" right="0">
          <Typography textStyle="b3">{numberInWords}</Typography>
        </Box>
      )}
    </div>
  );
};

export default NumberInputWithWords;
